export const API_PATH = process.env.REACT_APP_API_PATH ?? "/";
export const BUILD_VERSION = "20250627.1";
export const IMAGE_INTERVAL_CHANGE = 3000; // 3 secs
export const IDDLE_TIME =
  (process.env.REACT_APP_IDDLE_TIME &&
    Number(process.env.REACT_APP_IDDLE_TIME)) ||
  60 * 1000; // Default is 1 minutes
